import { SolutionPageTemplate } from '@/components/SolutionPageTemplate';
import { Home, Volume2, IndianRupee, Shield, Sun, Zap } from 'lucide-react';

export default function ApartmentsPage() {
  return (
    <SolutionPageTemplate
      slug="apartments"
      title="BESS for Apartments"
      subtitle="Residential Communities"
      description="Replace noisy diesel gensets with clean, silent battery power for your apartment complex. Solar + Storage for communities that care about clean air and lower costs."
      heroImage="/images/voltide-apartment.png"
      path="/solutions/apartments"
      sectorLabel="apartments"
      useCaseParam="dg_replacement"
      benefits={[
        { icon: Volume2, title: 'No DG Noise', desc: 'Completely silent backup. No more complaints about generator noise at night.' },
        { icon: Home, title: 'Common Area Power', desc: 'Lifts, water pumps, lighting, and security systems stay running during outages.' },
        { icon: IndianRupee, title: 'Lower CAM Charges', desc: 'Reduce common area maintenance costs with cheaper, cleaner backup power.' },
        { icon: Shield, title: 'Reliable Backup', desc: '2-6 hours of seamless backup with instant switchover. No flickering lights.' },
        { icon: Sun, title: 'Solar Ready', desc: 'Pair with rooftop solar to generate and store your own clean energy.' },
        { icon: Zap, title: 'EV Ready', desc: 'Support EV charging infrastructure for residents with smart load management.' },
      ]}
      howItWorks={[
        { title: 'Community Assessment', desc: 'We evaluate your common area loads, backup duration needs, and available space for the BESS unit.' },
        { title: 'RWA-Friendly Setup', desc: 'Containerised system placed in the generator room area. Quick installation with minimal disruption to residents.' },
        { title: 'Hassle-Free Operation', desc: 'Fully managed service. Monthly rental model means no capex burden on the association.' },
      ]}
      faqs={[
        { q: 'How does the RWA/association manage this?', a: 'Simple: Voltide handles everything. The association pays a monthly rental fee instead of diesel costs. No maintenance, no fuel procurement, no hassle.' },
        { q: 'Can it power individual flats?', a: 'BESS is designed for common area loads (lifts, pumps, lighting). Individual flat backup requires a different configuration which we can discuss.' },
        { q: 'What about fire safety in a residential area?', a: 'Our containerised systems include integrated fire suppression and meet all residential safety standards. The container provides physical isolation from the building.' },
      ]}
      productFilter={p => p.pcs_kw <= 500}
    />
  );
}
